import React, { createContext, useState, useContext, useEffect } from 'react';

const EventContext = createContext();

export const EventProvider = ({ children }) => {
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(false);

  const loadEventBySlug = async (slug) => {
    setLoading(true);
    try {
      // TODO: Remplacer par votre vraie API Airtable
      const response = await fetch(`https://matchmaking.mobivent.fr/api/event/${slug}`);
      const data = await response.json();
      
      if (data.success) {
        setEvent(data.event);
        // Sauvegarder dans localStorage
        localStorage.setItem('current_event', JSON.stringify(data.event));
      } else {
        setEvent(null);
      }
    } catch (error) {
      console.error('Error loading event:', error);
      setEvent(null);
    } finally {
      setLoading(false);
    }
  };

  const clearEvent = () => {
    setEvent(null);
    localStorage.removeItem('current_event');
  };

  // Charger l'événement depuis localStorage au démarrage
  useEffect(() => {
    const savedEvent = localStorage.getItem('current_event');
    if (savedEvent) {
      try {
        setEvent(JSON.parse(savedEvent));
      } catch (e) {
        console.error('Error parsing saved event:', e);
      }
    }
  }, []);

  return (
    <EventContext.Provider value={{ event, loading, loadEventBySlug, clearEvent }}>
      {children}
    </EventContext.Provider>
  );
};

export const useEvent = () => {
  const context = useContext(EventContext);
  if (!context) {
    throw new Error('useEvent must be used within an EventProvider');
  }
  return context;
};